import { render, staticRenderFns } from "./HeaderContentsWithNoLink.vue?vue&type=template&id=4487bb98&"
import script from "./HeaderContentsWithNoLink.vue?vue&type=script&lang=js&"
export * from "./HeaderContentsWithNoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports